import { render, staticRenderFns } from "./sideMenuB2b.vue?vue&type=template&id=9c5ccf3e&"
import script from "./sideMenuB2b.vue?vue&type=script&lang=js&"
export * from "./sideMenuB2b.vue?vue&type=script&lang=js&"
import style0 from "./sideMenuB2b.vue?vue&type=style&index=0&id=9c5ccf3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports